import _isEmpty from "lodash/isEmpty";
import React from 'react';
import { getAvailableTermLengths, getDisclaimer, getQualificationsBullets, getBottomLine } from '@nerdwallet/marketplace/selectors/education-loans';
import { mappings as quickFactMappings } from '@nerdwallet/react-quick-facts';
import { CONTENT_TABS } from '../lib/constants';
import Qualifications from '../loans-qualifications';
export default (function (_ref) {
  var bottomLine = _ref.bottomLine,
      marketplaceEntity = _ref.marketplaceEntity;
  var availableTermLengths = getAvailableTermLengths(marketplaceEntity);
  var disclaimer = getDisclaimer(marketplaceEntity);
  var qualifications = getQualificationsBullets(marketplaceEntity);
  return {
    activeContentTab: CONTENT_TABS.KEY_FACTS,
    bottomLine: null,
    drivers: [quickFactMappings.educationLoans.getQuickFactFixedAPRWithAnnotation(marketplaceEntity), quickFactMappings.educationLoans.getQuickFactVariableAPRWithAnnotation(marketplaceEntity), quickFactMappings.educationLoans.getQuickFactMinCreditScore(marketplaceEntity)],
    keyFacts: bottomLine || getBottomLine(marketplaceEntity),
    productDetails: !_isEmpty(qualifications) || availableTermLengths || disclaimer ? /*#__PURE__*/React.createElement(Qualifications, {
      bullets: qualifications,
      termLengths: availableTermLengths,
      disclaimer: disclaimer
    }) : null
  };
});